/** Контент лендинга `/use-cases/church-timer` (вёрстка — `UseCasePageLayout`). */

import type { UseCasePageContent } from './useCasePageContent';

export const CHURCH_TIMER_CONTENT: UseCasePageContent = {
  heroEyebrow: 'ЦЕРКОВЬ, БОГОСЛУЖЕНИЕ, ПРОПОВЕДЬ',
  heroLead:
    'Держите проповедь, прославление и каждую часть служения в графике. preztimer работает в браузере — без дорогого оборудования и установки. Управляйте с телефона, показывайте на любом экране.',
  heroNote: 'Бесплатно. Без регистрации, в браузере.',

  scenarios: {
    title: 'Чем заменяет привычные решения',
    lead:
      'Аппаратные таймеры, таймер в слайд-программе или бумажные таблички — у каждого свои ограничения. preztimer закрывает их браузером и телефоном.',
    items: [
      {
        title: 'Вместо дорогого «железа»',
        text: 'Аппаратные таймеры стоят дорого и показывают только лампочки. Здесь — время, сообщения и несколько экранов.',
      },
      {
        title: 'Вместо таймера в слайдах',
        text: 'Не привязан к компьютеру со слайдами: крупный отсчёт виден со сцены, а управление — с телефона.',
      },
      {
        title: 'Вместо табличек и жестов',
        text: 'Никто не машет из первого ряда — подсказки приходят прямо на экран спикеру.',
      },
    ],
  },

  share: {
    title: 'Просто управлять, легко делиться',
    paragraphs: [
      'preztimer — таймер с удалённым управлением: запускайте, ставьте на паузу и сбрасывайте отсчёт с любого устройства в браузере. Управляет один человек, видят все нужные экраны.',
      'Поделитесь экраном таймера по ссылке или QR-коду — без установки и регистрации. Сообщения на экране передают подсказки пастору и ведущим прямо во время служения.',
    ],
  },

  cloud: {
    title: 'Соберите порядок служения',
    lead:
      'Заведите таймеры на каждую часть и держите весь порядок под рукой — без лишних экранов и установки.',
    bullets: [
      'таймер на каждую часть: приветствие, прославление, проповедь, объявления;',
      'буфер между частями, чтобы заложить запас времени;',
      'переход к следующему таймеру — вручную с панели или с телефона.',
    ],
  },

  communication: {
    title: 'Подсказки спикеру без табличек',
    lead:
      'Пастор видит, сколько осталось, и получает короткие сигналы прямо на экран.',
    bullets: [
      'отсчёт на мониторе лицом к сцене или кафедре;',
      'сообщения «Завершайте» на экран спикеру — с телефона;',
      'цветовые зоны и показ перерасхода после нуля.',
    ],
  },

  modes: {
    title: 'Один таймер — на всех экранах',
    lead:
      'Один общий экран на монитор сцены, пульт звукорежиссёра и планшет ведущего — синхронно по ссылке.',
    bullets: [
      'отсчёт на нескольких экранах одновременно по одной ссылке;',
      'работает на любом устройстве с браузером, без оборудования;',
      'часы показывают местное время устройства — удобно для нескольких площадок.',
    ],
  },

  pricing: {
    title: 'Цены',
    lead:
      'Для небольшой церкви базовых функций хватит — бесплатно. Профи добавляет больше таймеров, комнат и подключений.',
  },

  crossLink: {
    title: 'Связанный сценарий: презентации и доклады',
    lead:
      'Один спикер и один экран с отсчётом рядом со слайдами — отдельная страница для докладов и выступлений.',
    to: '/use-cases/presentations',
    linkLabel: 'Таймер для презентаций и докладов',
  },

  faqSectionTitle: 'Частые вопросы о таймере для церкви',
  faqItems: [
    {
      question: 'Можно ли отмерять отдельные части служения?',
      answer:
        'Да. Создайте таймер на каждую часть — приветствие, прославление, проповедь, объявления. К следующему таймеру вы переходите вручную с панели управления, в том числе с телефона, если порядок служения меняется по ходу.',
    },
    {
      question: 'Видит ли пастор таймер так, чтобы прихожане его не видели?',
      answer:
        'Да. Откройте экран таймера на отдельном мониторе лицом к сцене или кафедре — его видит только спикер. Прихожане видят обычные слайды или ничего. Сообщения вроде «2 минуты» появляются только на экране спикера.',
    },
    {
      question: 'Нужно ли специальное оборудование или отдельный компьютер?',
      answer:
        'Нет. preztimer работает в браузере. Управляйте с ноутбука, планшета или телефона, а выводите на любой экран — ТВ за пультом, монитор на кафедре или ноутбук на сцене. Ни загрузок, ни отдельных «коробок».',
    },
    {
      question: 'Есть ли бесплатный вариант для небольшой церкви?',
      answer:
        'Да. На Базовом доступен полноценный таймер с 3 одновременными подключениями — это один пульт и два экрана. Без карты и регистрации: создайте комнату и начните отсчёт.',
    },
    {
      question: 'Справятся ли волонтёры без технической подготовки?',
      answer:
        'Да. Панель управления простая: старт, пауза, переход к следующему таймеру. Без переключателей и проприетарных программ — разберётся и новичок.',
    },
    {
      question: 'Работает ли без интернета?',
      answer:
        'Нет. preztimer работает онлайн в браузере, офлайн-приложения сейчас нет. Для служения нужен стабильный интернет на устройствах, где открыты панель и экран таймера.',
    },
  ],
};
